import React, { useEffect } from 'react';
import Router from './Router/Router';
import { BrowserRouter } from "react-router-dom";
import './App.css'
import AOS from 'aos';
import 'aos/dist/aos.css';
import ScrollToTop from './Components/ScrollToTop';


function App() {

  useEffect(() => {
    AOS.init({
      duration: 800, // animation duration in ms
      once: true     // whether animation should happen only once
    });
  }, []);
  
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Router />
    </BrowserRouter>
  );
}

export default App;
